// extracted by mini-css-extract-plugin
module.exports = {"Separate":"Separate_Separate__cGTfW","title":"Separate_title__meX3x","white":"Separate_white__2Xoh0","black":"Separate_black__1AJai","blue":"Separate_blue__3Fx-o"};